import React, {useEffect, useState} from 'react';

import {Container, Content, StationsList} from './styles';
import {Header} from '../../components/Interface/Headers/Header';

import {useIsFocused, useRoute} from '@react-navigation/native';
import {api} from '../../services/api';
import {StationItem} from '../../components/shared/Stations/StationItem';
import {Loading} from '../../components/Interface/Loadings/Loading';
import {StationDTO} from '../../dtos/StationDTO';
import {RFValue} from 'react-native-responsive-fontsize';
import {Titles} from '../../components/Interface/Typographies/Titles';

interface Params {
  region: string;
  tipo: string;
  showRank?: boolean;
  id_produto?: string;
}

export function Stations() {
  const screenIsFocused = useIsFocused();

  const route = useRoute();

  const {region, tipo, showRank, id_produto} = route.params as Params;

  const [isLoading, setIsLoading] = useState(true);

  const [data, setData] = useState<StationDTO[]>([] as StationDTO[]);

  useEffect(() => {
    let isMounted = true;
    async function fetchStations() {
      await api
        .get('/stations')
        .then(res => {
          if (isMounted) {
            const filteredStations = res.data.filter(
              (item: StationDTO) => item.state === region,
            );
            setData(filteredStations);
          }
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }

    async function fetchStationsByProductId() {
      await api
        .get('/listaPostosCompra', {
          params: {
            id_produto,
          },
        })
        .then(res => {
          if (isMounted) {
            setData(res.data);
          }
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }

    if (id_produto) {
      fetchStationsByProductId();
    } else {
      fetchStations();
    }

    return () => {
      isMounted = false;
    };
  }, [screenIsFocused]);

  return isLoading ? (
    <Loading />
  ) : (
    <Container>
      <Header icon="chevron-left" parentHelp />

      <Content
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{paddingBottom: RFValue(20)}}>
        {tipo === 'C' ? (
          <Titles
            title="Abasteça em qualquer um desses postos:"
            subtitle="Escolha locai onde você pode retirar seu produto ou serviço"
          />
        ) : (
          <Titles
            title="Retire em qualquer um desses locais:"
            subtitle="Locais para abastecer ou retirar o seu produto ou serviço"
          />
        )}

        <StationsList>
          {data.map(item => (
            <StationItem
              data={item}
              key={item.id}

              showRank={showRank ? true : false}
            />
          ))}
        </StationsList>
      </Content>
    </Container>
  );
}
